import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=1ad566ae&scoped=true&"
import script from "./Brands.vue?vue&type=script&lang=ts&"
export * from "./Brands.vue?vue&type=script&lang=ts&"
import style0 from "./Brands.vue?vue&type=style&index=0&id=1ad566ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad566ae",
  null
  
)

export default component.exports